export default function SanitaireGrid() {
  const products = [
    {
      name: 'Ensemble WC Geberit AquaClean',
      category: 'WC lavant suspendu',
      capacity: 'Modèle Sela',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20Geberit%20AquaClean%20Sela%20wall-hung%20shower%20toilet%20in%20pristine%20white%20ceramic%20with%20sleek%20modern%20design%2C%20premium%20Swiss%20bathroom%20fixture%20with%20integrated%20bidet%20function%20and%20soft-close%20seat%2C%20high-end%20sanitaryware%20with%20minimalist%20contemporary%20styling%2C%20professional%20product%20photography%20on%20white%20background&width=800&height=600&seq=geberit-aquaclean&orientation=portrait',
      features: ['Fonction lavante avec eau chaude', 'Séchage à air chaud', 'Détection de présence', 'Bâti-support Geberit Duofix', 'Plaque de commande design'],
      specs: { brand: 'Geberit', material: 'Céramique premium', warranty: '5 ans' }
    },
    {
      name: 'Robinetterie Hansgrohe Axor',
      category: 'Mitigeur lavabo design',
      capacity: 'Collection Citterio',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20Hansgrohe%20Axor%20Citterio%20bathroom%20faucet%20in%20polished%20chrome%20finish%20with%20minimalist%20geometric%20design%2C%20premium%20designer%20tap%20with%20single-lever%20control%20and%20precision%20engineering%2C%20luxury%20German%20sanitaryware%20with%20contemporary%20architectural%20styling%2C%20professional%20product%20photography%20showing%20sleek%20profile&width=800&height=600&seq=hansgrohe-axor&orientation=portrait',
      features: ['Design Antonio Citterio', 'Finition chromée brillante', 'Cartouche céramique longue durée', 'Limiteur de débit EcoSmart', 'Flexible de raccordement inclus'],
      specs: { brand: 'Hansgrohe', material: 'Laiton chromé', warranty: '5 ans' }
    },
    {
      name: 'Baignoire Kaldewei Meisterstück',
      category: 'Baignoire îlot acier émaillé',
      capacity: '180 x 80 cm',
      image: 'https://readdy.ai/api/search-image?query=Luxurious%20Kaldewei%20Meisterstuck%20freestanding%20bathtub%20in%20glossy%20white%20enamel%20steel%20with%20elegant%20oval%20shape%2C%20premium%20German%20designer%20bath%20with%20smooth%20curved%20lines%20and%20refined%20proportions%2C%20high-end%20bathroom%20centerpiece%20with%20timeless%20minimalist%20aesthetic%2C%20professional%20product%20photography%20in%20bright%20studio%20setting&width=800&height=600&seq=kaldewei-bath&orientation=portrait',
      features: ['Acier émaillé 3.5mm', 'Surface antibactérienne', 'Isolation phonique intégrée', 'Mitigeur îlot Hansgrohe', 'Vidage automatique'],
      specs: { brand: 'Kaldewei', material: 'Acier émaillé', warranty: '30 ans' }
    },
    {
      name: 'Douche Italienne Wedi',
      category: 'Receveur de douche à carreler',
      capacity: '120 x 90 cm',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Wedi%20Fundo%20shower%20base%20system%20with%20integrated%20waterproofing%20and%20tile-ready%20surface%2C%20premium%20German%20shower%20tray%20with%20linear%20drain%20and%20sloped%20design%2C%20professional%20bathroom%20installation%20product%20with%20blue%20waterproof%20coating%2C%20technical%20product%20photography%20showing%20construction%20details&width=800&height=600&seq=wedi-shower&orientation=portrait',
      features: ['Système Wedi Fundo Primo', 'Pente intégrée 2%', 'Caniveau de douche linéaire', 'Étanchéité garantie', 'Prêt à carreler'],
      specs: { brand: 'Wedi', material: 'Polystyrène extrudé', warranty: '10 ans' }
    },
    {
      name: 'Lavabo Villeroy & Boch',
      category: 'Vasque à poser design',
      capacity: 'Collection Artis',
      image: 'https://readdy.ai/api/search-image?query=Sophisticated%20Villeroy%20and%20Boch%20Artis%20countertop%20basin%20in%20matte%20white%20ceramic%20with%20organic%20round%20shape%2C%20premium%20designer%20washbasin%20with%20smooth%20sculptural%20form%20and%20refined%20edges%2C%20luxury%20European%20sanitaryware%20with%20contemporary%20minimalist%20design%2C%20professional%20product%20photography%20on%20neutral%20background&width=800&height=600&seq=vb-artis&orientation=portrait',
      features: ['Céramique TitanCeram', 'Finition mate ou brillante', 'Résistance aux rayures', 'Meuble sous-vasque assorti', 'Bonde design chromée'],
      specs: { brand: 'Villeroy & Boch', material: 'TitanCeram', warranty: '10 ans' }
    },
    {
      name: 'Colonne de Douche Grohe Rainshower',
      category: 'Système de douche thermostatique',
      capacity: 'Modèle 310',
      image: 'https://readdy.ai/api/search-image?query=Premium%20Grohe%20Rainshower%20310%20thermostatic%20shower%20system%20in%20polished%20chrome%20with%20large%20overhead%20shower%20head%2C%20luxury%20German%20shower%20column%20with%20hand%20shower%20and%20temperature%20control%2C%20high-end%20bathroom%20fixture%20with%20modern%20cylindrical%20design%2C%20professional%20product%20photography%20showing%20complete%20system&width=800&height=600&seq=grohe-rainshower&orientation=portrait',
      features: ['Douche de tête 310mm', 'Thermostat Grohtherm', 'Douchette à main 3 jets', 'Technologie CoolTouch', 'Finition StarLight chromée'],
      specs: { brand: 'Grohe', material: 'Laiton chromé', warranty: '5 ans' }
    },
    {
      name: 'Chauffe-eau Thermodynamique',
      category: 'Ballon thermodynamique',
      capacity: '250 litres',
      image: 'https://readdy.ai/api/search-image?query=Modern%20thermodynamic%20water%20heater%20tank%20in%20white%20cylindrical%20housing%20with%20integrated%20heat%20pump%20unit%20on%20top%2C%20energy-efficient%20hot%20water%20system%20with%20digital%20control%20panel%20and%20insulation%2C%20professional%20HVAC%20equipment%20with%20contemporary%20industrial%20design%2C%20technical%20product%20photography%20in%20clean%20setting&width=800&height=600&seq=thermo-water&orientation=portrait',
      features: ['COP jusqu\'à 3.5', 'Économies 70% vs électrique', 'Mode boost électrique', 'Isolation haute performance', 'Application de contrôle'],
      specs: { brand: 'Atlantic', material: 'Cuve émaillée', warranty: '5 ans' }
    },
    {
      name: 'Adoucisseur d\'Eau BWT',
      category: 'Système de traitement d\'eau',
      capacity: '15 litres de résine',
      image: 'https://readdy.ai/api/search-image?query=Compact%20BWT%20water%20softener%20system%20in%20white%20cabinet%20with%20digital%20display%20and%20control%20panel%2C%20professional%20water%20treatment%20equipment%20with%20modern%20design%20and%20transparent%20salt%20container%2C%20high-end%20residential%20water%20conditioning%20system%2C%20technical%20product%20photography%20showing%20front%20interface&width=800&height=600&seq=bwt-softener&orientation=portrait',
      features: ['Régénération automatique', 'Écran tactile couleur', 'Consommation optimisée sel', 'Bypass intégré', 'Garantie pièces 5 ans'],
      specs: { brand: 'BWT', material: 'Résine ionique', warranty: '5 ans' }
    },
    {
      name: 'Sèche-serviettes Zehnder',
      category: 'Radiateur salle de bain design',
      capacity: '750W - 120 x 60 cm',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20Zehnder%20designer%20towel%20radiator%20in%20matte%20white%20finish%20with%20horizontal%20bars%20and%20minimalist%20styling%2C%20premium%20Swiss%20bathroom%20heater%20with%20clean%20geometric%20lines%2C%20luxury%20heated%20towel%20rail%20with%20contemporary%20architectural%20design%2C%20professional%20product%20photography%20on%20white%20background&width=800&height=600&seq=zehnder-towel&orientation=portrait',
      features: ['Design suisse Zehnder', 'Thermostat digital programmable', 'Finitions multiples disponibles', 'Séchage rapide serviettes', 'Garantie fabricant 10 ans'],
      specs: { brand: 'Zehnder', material: 'Acier', warranty: '10 ans' }
    }
  ];

  return (
    <section id="produits" className="py-24 bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-orange-400">Nos Produits Sanitaires</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Équipements Premium pour Salles de Bains
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-400">
            Sanitaires haut de gamme des plus grandes marques européennes. Installation professionnelle avec finitions soignées.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {products.map((product, index) => (
            <div key={index} className="bg-gray-800 rounded-2xl border border-gray-700 overflow-hidden hover:border-orange-500/40 transition-all">
              <div className="relative w-full h-80 bg-gray-700">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {product.specs.brand}
                </div>
              </div>
              <div className="p-6">
                <div className="mb-4">
                  <p className="text-sm text-orange-400 font-semibold mb-1">{product.category}</p>
                  <h3 className="text-xl font-bold text-white mb-2">{product.name}</h3>
                  <p className="text-sm text-gray-400">{product.capacity}</p>
                </div>
                <ul className="space-y-2 mb-6">
                  {product.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-check-line text-orange-400 mt-1 mr-2 flex-shrink-0"></i>
                      <span className="text-sm text-gray-300">{feature}</span>
                    </li>
                  ))}
                </ul>
                <div className="border-t border-gray-700 pt-4 mb-6">
                  <div className="grid grid-cols-2 gap-3 text-sm">
                    <div>
                      <p className="text-gray-500">Matériau</p>
                      <p className="font-semibold text-gray-200">{product.specs.material}</p>
                    </div>
                    <div>
                      <p className="text-gray-500">Garantie</p>
                      <p className="font-semibold text-gray-200">{product.specs.warranty}</p>
                    </div>
                  </div>
                </div>
                <a href="#contact" className="block w-full text-center rounded-full bg-orange-500 px-6 py-3 text-sm font-semibold text-white hover:bg-orange-600 transition-all whitespace-nowrap cursor-pointer">
                  Demander un devis
                </a>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-12 bg-gray-800 rounded-2xl p-8 border border-orange-500/20">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-lg flex-shrink-0">
              <i className="ri-drop-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-2">Installation professionnelle garantie</h3>
              <p className="text-gray-400 leading-relaxed mb-4">
                Nos plombiers qualifiés assurent une installation dans les règles de l'art avec étanchéité garantie. Tous les raccordements sont testés et vérifiés avant la mise en service.
              </p>
              <p className="text-gray-400 leading-relaxed">
                <strong className="text-white">Service complet:</strong> Dépose de l'ancien équipement, installation du nouveau matériel, raccordements eau et évacuation, tests d'étanchéité, nettoyage du chantier. Garantie installation 2 ans.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
